import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    title: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      color: palette.darkGray,
    },
    subtitle: {
      color: palette.darkGray,
      display: 'flex',
      fontSize: 12,
      alignItems: 'center',
    },
    smallTitle: {
      fontFamily: 'Roboto',
      textTransform: 'none',
      fontSize: 12,
      opacity: 0.8,
    },
  });
